import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { CharacterEditorSelectableItem } from "./CharacterEditorSelectableItem";
import { undoableCharacterEditorSelectSkinClass } from "../../stores/undo/operation/CharacterEditorStateChangeOp";
import { getAllSkinClassNames } from "../../helper/spineHelper";
import { SkinClassIcon } from "./SkinClassIcon";
import { TabBorderColor } from "../game/ui components/GameUIElements";
import { GiRollingDices } from "react-icons/gi";
import { sharedStore } from "../../stores/SharedStore";
import { animationLoader } from "../../helper/AnimationLoader";
import { CharacterSelectionHelper } from "../../helper/CharacterSelectionHelper";
import { CharacterEditorChangeGroup, groupUndoableCharacterEditorChanges } from "../../stores/undo/operation/CharacterEditorSubmitCharacterConfigurationChangesOp";
const ContainerWidth = "130px";
const Container = styled.div.withConfig({
  displayName: "SelectionComponentSkinClass__Container",
  componentId: "sc-7jhu8f-0"
})(["display:flex;flex-direction:column;flex-grow:1;width:", ";&.selected{border-right:", " 4px solid;}"], () => ContainerWidth, TabBorderColor);
const ClassButtonContainer = styled(CharacterEditorSelectableItem).withConfig({
  displayName: "SelectionComponentSkinClass__ClassButtonContainer",
  componentId: "sc-7jhu8f-1"
})(["width:111px;height:60px;align-items:center;justify-content:center;text-align:center;&.selected{width:", ";background-color:#000000;border-right:0;border-top-right-radius:0;border-bottom-right-radius:0;border-color:", ";}"], () => ContainerWidth, TabBorderColor);
const RandomizeButtonContainer = styled(CharacterEditorSelectableItem).withConfig({
  displayName: "SelectionComponentSkinClass__RandomizeButtonContainer",
  componentId: "sc-7jhu8f-2"
})(["width:80px;height:80px;align-items:center;justify-content:center;text-align:center;"]);
export const SelectionComponentSkinClass = observer(props => {
  const [classNames, setClassNames] = useState([]);
  const animationStore = props.store.animationSelectionStore;

  function onSkinClassSelected(className) {
    undoableCharacterEditorSelectSkinClass(className, props.store);
  }

  useEffect(() => {
    var _animationStore$selec, _animationStore$selec2, _animationStore$selec3, _animationStore$selec4;

    setClassNames(getAllSkinClassNames((_animationStore$selec = animationStore.selectedAnimation) === null || _animationStore$selec === void 0 ? void 0 : (_animationStore$selec2 = _animationStore$selec.spine) === null || _animationStore$selec2 === void 0 ? void 0 : (_animationStore$selec3 = _animationStore$selec2.skeleton) === null || _animationStore$selec3 === void 0 ? void 0 : (_animationStore$selec4 = _animationStore$selec3.data) === null || _animationStore$selec4 === void 0 ? void 0 : _animationStore$selec4.skins));
  }, [animationStore.selectedAnimation]);
  return /*#__PURE__*/React.createElement(Container, {
    className: animationStore.selectedSkinClass ? "selected" : ""
  }, classNames.map(name => /*#__PURE__*/React.createElement(ClassButtonContainer, {
    key: name,
    className: animationStore.selectedSkinClass == name ? "selected" : "",
    onClick: () => onSkinClassSelected(name)
  }, /*#__PURE__*/React.createElement(SkinClassIcon, {
    className: name
  }))), classNames.length > 0 && /*#__PURE__*/React.createElement(RandomizeButtonContainer, {
    onClick: async () => {
      const {
        selectedCharacterConfiguration
      } = props.store;
      const animationAsset = sharedStore.getAnimationByName(selectedCharacterConfiguration.animationAssetName);
      if (!animationAsset) return;
      const {
        skins
      } = await animationLoader.loadAnimationDataCached(animationAsset.id);
      groupUndoableCharacterEditorChanges(CharacterEditorChangeGroup.UnspecificGroupedChanges, () => {
        CharacterSelectionHelper.randomizeSkinSelection(skins, selectedCharacterConfiguration);
      });
    }
  }, /*#__PURE__*/React.createElement(GiRollingDices, {
    size: 50
  })));
});